// Copyright (c) Mysten Labs, Inc. — DGC: /wallet route (应用中心)
// SPDX-License-Identifier: Apache-2.0

import {
	createBrowserRouter,
	Navigate,
	useLocation,
	useParams,
} from 'react-router-dom';

import { Layout } from '~/components/Layout';
import { IdPage } from '~/pages/id-page';
import AddressResult from './address-result/AddressResult';
import CheckpointDetail from './checkpoints/CheckpointDetail';
import EpochDetail from './epochs/EpochDetail';
import Home from './home/Home';
import { ObjectResult } from './object-result/ObjectResult';
import { Recent } from './recent';
import TransactionResult from './transaction-result/TransactionResult';
import { ValidatorDetails } from './validator/ValidatorDetails';
import CpcTradePage from './trade/CpcTradePage';
import CpcBridgePage from './bridge/CpcBridgePage';
import CpcBridgeHistoryPage from './bridge/CpcBridgeHistoryPage';
import CpcWalletPage from './wallet/CpcWalletPage';
import CpcStakePage from './stake/CpcStakePage';
import CpcGenesisPage from './genesis/CpcGenesisPage';

function RedirectWithId({ base }: { base: string }) {
	const params = useParams();
	const { search } = useLocation();
	return <Navigate to={`/${base}/${params.id}${search}`} replace />;
}

export const router = createBrowserRouter([
	{
		path: '/',
		element: <Layout />,
		children: [
			{ path: '/', element: <Home /> },
			{ path: 'recent', element: <Recent /> },
			{ path: 'wallet', element: <CpcWalletPage /> },
			{ path: 'stake', element: <CpcStakePage /> },
			{ path: 'genesis', element: <CpcGenesisPage /> },
			{ path: 'trade', element: <CpcTradePage /> },
			{ path: 'bridge/history', element: <CpcBridgeHistoryPage /> },
			{ path: 'bridge', element: <CpcBridgePage /> },
			{ path: 'object/:id', element: <ObjectResult /> },
			{ path: 'checkpoint/:id', element: <CheckpointDetail /> },
			{ path: 'epoch/current', element: <EpochDetail /> },
			{ path: 'txblock/:id', element: <TransactionResult /> },
			{ path: 'epoch/:id', element: <EpochDetail /> },
			{ path: 'address/:id', element: <AddressResult /> },
			{ path: 'validators', element: <Navigate to={{ pathname: '/stake', hash: '#validators' }} replace /> },
			{ path: 'validator/:id', element: <ValidatorDetails /> },
			{ path: 'experimental--id/:id', element: <IdPage /> },
		],
	},
	{
		path: '/transactions',
		element: <Navigate to="/recent" replace />,
	},
	{
		path: '/objects/:id',
		element: <RedirectWithId base="object" />,
	},
	{
		path: '/transaction/:id',
		element: <RedirectWithId base="txblock" />,
	},
	{
		path: '/transactions/:id',
		element: <RedirectWithId base="txblock" />,
	},
	{
		path: '/addresses/:id',
		element: <RedirectWithId base="address" />,
	},
	{ path: '*', element: <Navigate to="/" replace /> },
]);
